import { ShaderStore } from "@babylonjs/core/Engines/shaderStore";
const Name = "textureAlphaCheckerVertexShader";
const Shader = /* wgsl */ "\nattribute uv: vec2f;varying vUv: vec2f;@vertex\nfn main(input: VertexInputs)->FragmentInputs {vertexOutputs.vUv=vertexInputs.uv;vertexOutputs.position=vec4f(\n(vertexInputs.uv % 1.0)*2.0-1.0,\n0.0,\n1.0\n);}\n";
// Sideeffect
ShaderStore.ShadersStoreWGSL[Name] = Shader;
/** @internal */
export const TextureAlphaCheckerVertexShader = { name: Name, shader: Shader };
